import type { StyleRules, MakeStylesHook } from '@egr/xbox/utils/tss-react';
import type * as React from 'react';

import { makeStyles } from '@egr/xbox/utils/tss-react';

type WrapperStyleRules = 'l1' | 'l2' | 'l3';

function styles(): StyleRules<WrapperStyleRules> {
    return {
        l1: {
            height: '100%',
            overflow: 'auto',
            textAlign: 'center',
            width: '100%',
            top: 0,
            left: 0,
        },
        l2: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        },
        l3: {
            flex: '0 0 auto',
            margin: 'auto',
            maxWidth: 'calc(100% - 40px)',
            padding: 20,
            width: 640,
        },
    };
}

const useStyles: MakeStylesHook<WrapperStyleRules> = makeStyles({ name: 'App' })(styles);

interface WrapperProps {
    className?: string;
    children?: React.ReactNode;
}

const Wrapper: React.FC<WrapperProps> = ({ className, children }) => {
    const { classes } = useStyles();
    let l1ClassName: string = '';

    if (className) {
        l1ClassName += ' ' + className;
    }

    return (
        <div className={classes.l1 + l1ClassName}>
            <div className={classes.l2}>
                <div className={classes.l3}>{children}</div>
            </div>
        </div>
    );
};

export default Wrapper;
